import type { FC } from "react";
import React from "react";
import { Body, Link } from "@edreamsodigeo/prisma-design-system";

import type { LinkProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/contracts";

export const LinkComponent: FC<LinkProps> = ({ href, text }) => (
  <Link variant={"legal"} target={"_blank"} href={href}>
    <Body inline type={"xSmall"} sx={{ textDecoration: "underline" }}>
      {text}
    </Body>
  </Link>
);
